import { render, staticRenderFns } from "./tabNav.vue?vue&type=template&id=e15b2896&scoped=true"
import script from "./tabNav.vue?vue&type=script&lang=js"
export * from "./tabNav.vue?vue&type=script&lang=js"
import style0 from "./tabNav.vue?vue&type=style&index=0&id=e15b2896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15b2896",
  null
  
)

export default component.exports